<template>
  <div class="acomodar">
      <SeguimientoSolicitudContra/>
  </div>
</template>

<script>
import SeguimientoSolicitudContra from '@/components/ModSeleccion/Seguimiento/SegDatosPostulante.vue';
export default {
  name: "SeguimientodeSolicitud",
  data() {
      return {};
  },
  mounted() {
  },

  created(){
      this.cambiarEstadoNavbar()
  },
  methods: {
      
  cambiarEstadoNavbar() {
    // Acción directa para cambiar el estado del navbar a true
    this.$store.dispatch('acciones/CambioNavbar', true);
  }

  },
  components: {SeguimientoSolicitudContra} 
};
</script>